var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33331 8.5C1.33331 4.82 4.31998 1.83334 7.99998 1.83334C11.68 1.83334 14.6666 4.82 14.6666 8.5C14.6666 12.18 11.68 15.1667 7.99998 15.1667C4.31998 15.1667 1.33331 12.18 1.33331 8.5ZM3.79998 8.96667L6.19331 11.36C6.45331 11.62 6.87998 11.62 7.13331 11.36L12.1933 6.3C12.4533 6.04 12.4533 5.62 12.1933 5.36C11.9333 5.1 11.5133 5.1 11.2533 5.36L6.66665 9.94667L4.73998 8.02667C4.47998 7.76667 4.05998 7.76667 3.79998 8.02667C3.67514 8.15122 3.60499 8.32032 3.60499 8.49667C3.60499 8.67301 3.67514 8.84211 3.79998 8.96667Z",
    fill: "#007634"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleGreen);
export default __webpack_public_path__ + "static/media/check_circleGreen.1d11e0a79e49f2e739202f7ed0fe205b.svg";
export { ForwardRef as ReactComponent };